module.exports = __webpack_public_path__ + "img/search-regular.1f91fec6.svg";